/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-01
 * @brief EHP DashBoard - e-HC Status 컴포넌트
 *
 ********************************************************************/
import React, { useState, useEffect } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState, urlState, czoneInfoState } from "../../../recoil/menuState";
import * as CONST from "../../../utils/Const";
import * as CUTIL from "../../../utils/commUtils";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
/**
* @brief EHP DashBoard - e-HC Status 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
//component
function EhcStaus(props) {
    //trans, ref, navigate
    const navigate = useNavigate();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const [czoneInfo, setRecoilCZoneInfo] = useRecoilState(czoneInfoState);
    const [isLoadingBox, setRecoilIsLoadinBox] = useRecoilState(loadingBoxState);
    //props
    const selTree = props.selTree;
    //
    const spgList = [
        { "id": 0, "spgDisp": "전체", "spgVal": "" },
        { "id": 1, "spgDisp": "VCB", "spgVal": "VCB" },
        { "id": 2, "spgDisp": "ACB", "spgVal": "ACB" },
        { "id": 3, "spgDisp": "MoldTR", "spgVal": "MoldTR" },
        { "id": 4, "spgDisp": "유입식TR", "spgVal": "유입식TR" },
        { "id": 5, "spgDisp": "GIS", "spgVal": "GIS" },
        { "id": 6, "spgDisp": "배전반", "spgVal": "배전반" },
    ];
    const [spg, setSpg] = useState(spgList[0]);
    useEffect(() => {
        setSpg(spgList[0]);
    }, [selTree]);
    // option 선택 시  값 변경 액션
    function selectOptionSpg(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        setSpg(JSON.parse(optionData));
    }
    const [ehpStatus, setEhpStatus] = useState({
        "totalCount": 0,
        "progressCount": 0,
        "basicCount": 0,
        "basicProgress": 0,
        "premiumCount": 0,
        "premiumProgress": 0,
        "advancedCount": 0,
        "advancedProgress": 0,
        "normalCount": 0,
        "normalProgress": 0,
        "requestedCount": 0,
        "acceptedCount": 0,
        "ingCount": 0
    });
    function handleEhpStatus(val) {
        setEhpStatus(Object.assign(Object.assign({}, val), { "basicProgress": (val.totalCount === 0) ? 0 : Math.round(val.basicCount / val.totalCount * 100), "premiumProgress": (val.totalCount === 0) ? 0 : Math.round(val.premiumCount / val.totalCount * 100), "advancedProgress": (val.totalCount === 0) ? 0 : Math.round(val.advancedCount / val.totalCount * 100), "normalProgress": (val.totalCount === 0) ? 0 : Math.round(val.normalCount / val.totalCount * 100) }));
    }
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/maindashboard/ehcstatus?zoneId=${selTree.zone.zoneId}&spgList=${spg.spgVal}`,
        appQuery: {
        /*"zoneId" : selTree.zone.zoneId,
        "spgList" : spg.spgVal*/
        },
        userToken: userInfo.loginInfo.token,
        watch: selTree.zone.zoneId + spg.spgVal,
        //watch: selTree+spg,
    });
    useEffect(() => {
        setRecoilIsLoadinBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (retData) {
            setRecoilIsLoadinBox(false);
            //clog("IN INFOCARS : EHP STATUS : RES : " + JSON.stringify(retData.body));
            if (retData.codeNum == CONST.API_200) {
                handleEhpStatus(retData.body);
                //clog("PIN LC INFO : " + czoneStr);
            }
        }
    }, [retData]);
    function onClickGoLink(url) {
        setRecoilCZoneInfo(selTree);
        setRecoilUrlInfo(url);
        navigate(url);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "box__header" },
            React.createElement("p", { className: "box__title" }, "e-HC Status"),
            React.createElement("div", { className: "box__etc" },
                React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectOptionSpg) },
                    React.createElement("div", { className: "selected" },
                        React.createElement("div", { className: "selected-value" }, spg.spgDisp),
                        React.createElement("div", { className: "arrow" })),
                    React.createElement("ul", null, spgList.map((spg, idx) => (React.createElement("li", { key: `li_${idx.toString()}`, className: "option", "data-value": JSON.stringify(spg) }, spg.spgDisp))))))),
        React.createElement("div", { className: "box__body" },
            React.createElement("div", { className: "top" },
                React.createElement("div", { className: "left mt-5" },
                    React.createElement("p", { className: "txt-info" }, "\uC9C4\uB2E8\uC810\uAC80\uC774 \uD544\uC694\uD55C \uC124\uBE44\uAC00 \uC874\uC7AC\uD569\uB2C8\uB2E4.")),
                React.createElement("div", { className: "right inline" },
                    React.createElement("p", { className: "total-num" },
                        React.createElement("strong", null, ehpStatus.progressCount),
                        React.createElement("span", null,
                            " /",
                            ehpStatus.totalCount),
                        "ea"),
                    React.createElement("button", { type: "button", className: "btn btn-go", onClick: (e) => onClickGoLink(CONST.URL_MAIN_DASHBOARD) },
                        React.createElement("span", { className: "hide" }, "\uBC14\uB85C\uAC00\uAE30")))),
            React.createElement("div", { className: "progresscircle-wrap mt-40" },
                React.createElement("div", { className: "progress-circle" },
                    React.createElement("div", { className: "percent" },
                        React.createElement("svg", null,
                            React.createElement("circle", { cx: "40", cy: "40", r: "35" }),
                            React.createElement("circle", { cx: "40", cy: "40", r: "35", style: { "stroke": "#5b71ef" }, strokeDasharray: `${2 * Math.PI * 35 * (ehpStatus.basicProgress / 100)} ${2 * Math.PI * 35 * (1 - ehpStatus.basicProgress / 100)}`, strokeDashoffset: `${2 * Math.PI * 35 * 0.25}` })),
                        React.createElement("div", { className: "number" },
                            React.createElement("p", null, ehpStatus.basicCount))),
                    React.createElement("div", { className: "title" },
                        React.createElement("h3", null,
                            React.createElement("img", { src: require("/static/img/icon_b.png"), style: { "width": "16px", "height": "16px" }, alt: "Basic" }),
                            "Basic"))),
                React.createElement("div", { className: "progress-circle" },
                    React.createElement("div", { className: "percent" },
                        React.createElement("svg", null,
                            React.createElement("circle", { cx: "40", cy: "40", r: "35" }),
                            React.createElement("circle", { cx: "40", cy: "40", r: "35", style: { "stroke": "#13a79e" }, strokeDasharray: `${2 * Math.PI * 35 * (ehpStatus.premiumProgress / 100)} ${2 * Math.PI * 35 * (1 - ehpStatus.premiumProgress / 100)}`, strokeDashoffset: `${2 * Math.PI * 35 * 0.25}` })),
                        React.createElement("div", { className: "number" },
                            React.createElement("p", null, ehpStatus.premiumCount))),
                    React.createElement("div", { className: "title" },
                        React.createElement("h3", null,
                            React.createElement("img", { src: require("/static/img/icon_p.png"), style: { "width": "16px", "height": "16px" }, alt: "Premium" }),
                            "Premium"))),
                React.createElement("div", { className: "progress-circle" },
                    React.createElement("div", { className: "percent" },
                        React.createElement("svg", null,
                            React.createElement("circle", { cx: "40", cy: "40", r: "35" }),
                            React.createElement("circle", { cx: "40", cy: "40", r: "35", style: { "stroke": "#ff9900" }, strokeDasharray: `${2 * Math.PI * 35 * (ehpStatus.advancedProgress / 100)} ${2 * Math.PI * 35 * (1 - ehpStatus.advancedProgress / 100)}`, strokeDashoffset: `${2 * Math.PI * 35 * 0.25}` })),
                        React.createElement("div", { className: "number" },
                            React.createElement("p", null, ehpStatus.advancedCount))),
                    React.createElement("div", { className: "title" },
                        React.createElement("h3", null,
                            React.createElement("img", { src: require("/static/img/icon_a.png"), style: { "width": "16px", "height": "16px" }, alt: "Advanced" }),
                            "Advanced"))),
                React.createElement("div", { className: "progress-circle" },
                    React.createElement("div", { className: "percent" },
                        React.createElement("svg", null,
                            React.createElement("circle", { cx: "40", cy: "40", r: "35" }),
                            React.createElement("circle", { cx: "40", cy: "40", r: "35", style: { "stroke": "#1fc95c" }, strokeDasharray: `${2 * Math.PI * 35 * (ehpStatus.normalProgress / 100)} ${2 * Math.PI * 35 * (1 - ehpStatus.normalProgress / 100)}`, strokeDashoffset: `${2 * Math.PI * 35 * 0.25}` })),
                        React.createElement("div", { className: "number" },
                            React.createElement("p", null, ehpStatus.normalCount))),
                    React.createElement("div", { className: "title" },
                        React.createElement("h3", null, "Normal")))),
            React.createElement("div", { className: "bottom line mt-50" },
                React.createElement("div", { className: "top" },
                    React.createElement("h2", null, "Work Order"),
                    React.createElement("button", { type: "button", className: "btn btn-go", onClick: (e) => onClickGoLink(CONST.URL_SERVICEWORKORDER) },
                        React.createElement("span", { className: "hide" }, "\uBC14\uB85C\uAC00\uAE30"))),
                React.createElement("ul", { className: "step-order" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC694\uCCAD"),
                        React.createElement("p", { className: "total-num" },
                            React.createElement("strong", null, ehpStatus.requestedCount),
                            React.createElement("span", null, " ea"))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC811\uC218"),
                        React.createElement("p", { className: "total-num" },
                            React.createElement("strong", null, ehpStatus.acceptedCount),
                            React.createElement("span", null, " ea"))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC9C4\uD589 \uC911"),
                        React.createElement("p", { className: "total-num" },
                            React.createElement("strong", null, ehpStatus.ingCount),
                            React.createElement("span", null, " ea"))))))));
}
export default EhcStaus;
